<template>
	<div class="pt-5">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<v-card-text v-else-if="isBlocked !== null">
			<div class="note__search-wrapper">
				<h2 v-if="!isSearch" class="note__search-wrapper__title">Choose a Person</h2>
				<div
					v-if="isSearch"
					style="width: 100%"
					:class="[
						'note__search-wrapper__input',
						{ 'note__search-wrapper__active': isInputFocused || filters.search },
					]"
				>
					<div class="d-flex align-center">
						<input
							type="text"
							class="px-3 py-2"
							placeholder="Search"
							v-model="filters.search"
							@input="filterSearch"
							@focus="isInputFocused = true"
							@blur="isInputFocused = false"
							@click="dwhClickSearchNotesUser"
						/>
						<button @click="handlerSearch" type="button" class="px-2 py-2">
							<Icon type="search" :size="24" color="var(--button-icon-tint)" />
						</button>
					</div>
				</div>
				<button
					v-if="!isSearch"
					@click="handlerSearch"
					type="button"
					class="note__search-wrapper__search-button"
				>
					<Icon type="search" :size="24" color="var(--button-icon-tint)" />
				</button>
			</div>

			<div>
				<v-skeleton-loader
					v-if="isLoading"
					type="list-item-avatar, list-item-avatar, list-item-avatar"
				></v-skeleton-loader>
				<div v-else>
					<UserAddNoteItem
						v-for="user in users"
						:key="user.user_id"
						:user="user"
						:selectedUser="selectedUser"
						v-on:selectUser="selectUser"
					/>
				</div>
				<div
					class="note__search-wrapper__not-found"
					v-if="!isLoading && users.length === 0"
				>
					Person not found
				</div>
			</div>

			<div
				class="d-flex my-9 justify-center notes-page__pagination"
				v-if="!isLoading && users.length > 0"
			>
				<Pagination
					:page="filters.page"
					:pageCount="+this.pageCountAttendees"
					v-on:pageChange="onPageChange"
				/>
			</div>
		</v-card-text>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import searchIcon from '@/assets/images/search.svg'
import UserAddNoteItem from '@/components/Profile/UserAddNoteItem.vue'
import Pagination from '@/components/Pagination.vue'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import dwh from '@/mixins/Dwh'

const DEBOUNCE_TIMEOUT = 500

export default {
	components: {
		UserAddNoteItem,
		Pagination,
		PageBlocked,
	},
	mixins: [Block, dwh],
	data() {
		return {
			searchIcon,
			filters: {
				page: 1,
				search: '',
			},
			isInputFocused: false,
			selectedUser: null,
			pageBlockedName: 'profile',
			isSearch: false,
		}
	},
	computed: {
		...mapGetters('event', ['isLoading', 'pageCountAttendees', 'attendees']),
		...mapGetters('auth', ['profile']),
		...mapGetters('settings', ['appCore']),

		users() {
			return this.attendees
		},
		currentUser() {
			return this.profile
		},
	},
	methods: {
		...mapActions('event', ['getAttendeesEvent', 'clearAttendeesEvent']),
		dwhClickSearchNotesUser() {
			this.sendTrigger({
				category: 'Notes',
				action: 'click_search_notes_user',
				module: 'My Account',
				title: 'My Notes',
				id1: this.currentUser.user_id,
			})
		},
		handlerSearch() {
			this.isSearch = !this.isSearch
		},

		filterSearch(e) {
			clearTimeout(this.timer)

			this.filters.page = 1

			this.timer = setTimeout(() => {
				this.getAttendeesEvent(`?page=${1}&search=${e.target.value}`)
			}, DEBOUNCE_TIMEOUT)
		},

		onPageChange(page) {
			if (page !== this.filters.page) {
				this.filters.page = page
				this.getAttendeesEvent(`?page=${page}&search=${this.filters.search}`)
			}
		},
		selectUser(user) {
			this.selectedUser = user
		},
	},
	created() {
		!this.isBlocked && this.getAttendeesEvent()
	},
	beforeDestroy() {
		this.clearAttendeesEvent()
	},
}
</script>

<style lang="scss">
.note {
	&__search-wrapper {
		font-family: 'Inter', sans-serif;
		display: flex;
		gap: 16px;
		height: 40px;
		align-items: center;
		justify-content: space-between;
		border-radius: 8px;
		margin-bottom: 16px;
		&__not-found {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			width: 100%;
			height: 730px;
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 16px;
			line-height: 100%;
			letter-spacing: 0;
			text-align: center;
			color: #4a4a4a;
		}
		&__title {
			font-weight: 700;
			font-size: 24px;
			line-height: 100%;
			letter-spacing: 0;
			color: #4a4a4a;
		}
		&__search-button {
			width: 40px;
			height: 40px;
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 8px;
			border: 1px solid #e2e2e2;
			background-color: #ffffff;
		}
		&__input {
			border: 1px solid #e2e2e2;
			border-radius: 8px;
			background-color: #ffffff;
			height: 40px;
			input {
				font-family: 'Inter', sans-serif;
				font-weight: 400;
				font-size: 14px;
				line-height: 100%;
				letter-spacing: 0;
				color: #4a4a4a;
				outline: none;
				width: 100%;
			}
		}
		&__active {
			border: 1.5px solid var(--vote_bar_tint);
			box-shadow: 0 0 0 2px #0055a333;
		}
	}
}
</style>
